export const parseApiError = async (error, form) => {
    let errorBody
    if (error?.response instanceof Response) {
        try {
            errorBody = await error.response.clone().json()
        } catch {
            const text = await error.response.text()
            try {
                errorBody = JSON.parse(text)
            } catch {
                errorBody = {message: text}
            }
        }
    }
    return errorBody
}
